import { Component, inject, OnChanges, Input as RouterInput, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ActivatedRoute } from '@angular/router';
import { SafePipe } from 'safe-pipe';
import { FileService } from '../file/file.service';
import { BaseComponent } from '../shared/base.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
    selector: 'app-pdf-viewer',
    standalone: true,
    imports: [
        SafePipe,
        SiteHeaderComponent
    ],
    templateUrl: './pdf-viewer.component.html',
    styleUrl: './pdf-viewer.component.css'
})
export class PdfViewerComponent extends BaseComponent implements OnChanges {

    @RouterInput() category: string = "";
    @RouterInput() name: string = "";

    private route: ActivatedRoute = inject(ActivatedRoute);
    private fileService: FileService = inject(FileService);

    private static _downloadPdf = "Downloading Document";
    private static _downloadingPdfError = `${PdfViewerComponent._downloadPdf} error:`;

    private _pdfDoc: WritableSignal<string> = signal<string>("");

    // ToDo - Implement solution to cache PDF so that it doesn't
    // have to be downloaded every time the component is loaded.

    public ngOnChanges(changes: SimpleChanges) {
        this.getPdfUrl(this.category, this.name);
    }

    protected get pdfDoc(): string {
        return this._pdfDoc()
    }

    protected async getPdfUrl(category: string, name: string) {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const observable = this.fileService.getDownloadUrl(await getIdToken(currentUser), category, name);
            super.showSnackBar(`${PdfViewerComponent._downloadPdf}...`, -1);

            try {
                observable.subscribe(response => {
                    const json = JSON.parse(JSON.stringify(response));

                    if (json[`get-${category}-download-url`] == "success") {
                        this._pdfDoc.set(json.url);
                        super.dismissSnackBar();
                    } else {
                        throw new Error(json["message"]);
                    }
                });
            } catch (error) {
                const message = `${PdfViewerComponent._downloadingPdfError} ${(<Error>error).message}`;
                console.error(message);
                super.showSnackBar(message, 30);
           }
        } else {
            const message = `${PdfViewerComponent._downloadingPdfError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
